{
	"altLogo": "Logo",
	"ariaAiStyleInUse": "AI Style Already In Use",
	"ariaApplyAiStyle": "Apply AI Style",
	"ariaGoBack": "Go Back",
	"ariaLoadingAiStyle": "Loading AI Style...",
	"ariaUseAiStyle": "Use AI Style",
	"byAuthor": "by {{author}}",
	"createdOn": "Created on {{date}}",
	"inUse": "AI Style in use",
	"loadingAiStyle": "Loading AI Style...",
	"useAiStyle": "Use AI Style",
	"useStyleTitle": "Use {{title}}",
	"usingReferences": "Using {{count}} Reference Images"
}
